export default __webpack_public_path__ + "img/21e7d9ba9756b7a301caafd489cab277.png";